<template>
    <v-container grid-list-sm text-xs-left>
        <v-toolbar flat color="white">
            <v-toolbar-title>Users</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-flex xs12 md4 class="pl-3">
                <v-text-field
                        class="pt-1"
                        v-model="search"
                        :append-icon="search?'close':'search'"
                        @click:append="search = ''"
                        label="Search"
                        single-line
                        hide-details
                        @keydown.native.escape="search=''">
                </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="openNewUser">New User</v-btn>
        </v-toolbar>
        <v-data-table
                :headers="headers"
                :search="search"
                :items="users"
                :rows-per-page-items='[5, 10, 25, 50, 100]'
                :pagination.sync="pagination"
                class="elevation-1"
        >
            <template v-slot:items="props">
                <td class="justify-center align-center layout px-0 pt-2">
                    <v-icon
                            small
                            class="mr-2"
                            @click="editItem(props.item)"
                    >
                        edit
                    </v-icon>
                    <v-icon
                            small
                            class="mr-2"
                            @click="changePassword(props.item)"
                    >
                        mdi-key-variant
                    </v-icon>
                    <v-icon
                            small
                            @click="deleteIcon(props.item)"
                    >
                        delete
                    </v-icon>
                </td>
                <td class="text-xs-center">{{ props.item.username }}</td>
                <td class="text-xs-center">{{ props.item.firstName }}</td>
                <td class="text-xs-center">{{ props.item.lastName }}</td>
                <td class="text-xs-center">{{ props.item.email }}</td>
                <td class="text-xs-center">{{ props.item.roleName }}</td>
                <td class="text-xs-center">{{ props.item.groupName }}</td>
                <td class="text-xs-center">{{ props.item.creationDate }}</td>
            </template>
        </v-data-table>


        <!-- Dialog: Delete confirm -->
        <v-dialog
                v-model="dialogDeleteConfirm"
                max-width="500px"
                persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">Deletion confirmation</span>
                </v-card-title>

                <v-card-text>
                    <v-flex>
                        <span class="subheading">Are you sure you want to delete this user?</span>
                    </v-flex>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            round
                            color="red"
                            flat
                            @click="dialogDeleteConfirm=false"
                    >
                        NO
                    </v-btn>
                    <v-btn
                            round
                            color="green"
                            flat
                            @click="deleteUser()"
                    >
                        YES
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- New user -->
        <v-dialog
                v-model="newUserDialog"
                max-width="800px"
                persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">{{newUserDialogText}}</span>
                    <v-spacer></v-spacer>
                    <v-card-actions>
                        <v-btn icon @click="newUserDialog=false"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-actions>
                </v-card-title>


                <v-card-text>
                    <NewUser ref="newUser" :groups="groups" @submit="closeDialog"></NewUser>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Change password -->
        <v-dialog
                v-model="changePasswordDialog"
                max-width="800px"
                persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">Change password</span>
                    <v-spacer></v-spacer>
                    <v-card-actions>
                        <v-btn icon @click="changePasswordDialog=false"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-actions>
                </v-card-title>

                <v-card-text>
                    <ChangePassword ref="changePassword" @submit="closeDialogPassword"></ChangePassword>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import NewUser from "@/pages/SuperAdmin/NewUser";
    import ChangePassword from "@/pages/SuperAdmin/ChangePassword";
    import {mapGetters,mapState} from "vuex";


    export default {
        name: "UserManagement",
        components: {NewUser,ChangePassword},
        data() {
            return {
                search: '',
                changePasswordDialog: false,
                newUserDialogText: "",
                newUserDialog: false,
                headers: [
                    {text: "Actions", value: "action", align: "center", sortable: false,},
                    {text: 'Username', align: "center", value: 'username' },
                    {text: 'First Name', align: "center", value: 'firstName' },
                    {text: 'Last Name', align: "center", value: 'lastName' },
                    {text: 'Email', align: "center", value: 'email' },
                    {text: 'Role', align: "center", value: 'roleName' },
                    {text: 'Group', align: "center", value: 'groupName' },
                    {text: 'Creation Date', align: "center", value: 'creationDate' },
                ],
                pagination: {'sortBy': 'creationDate', 'descending': true,},

                users: [],
                itemToDelete: null,
                dialogDeleteConfirm: false,
                groups: []
            }
        },
        computed: {
            ...mapState({}),
            ...mapGetters('UserState', {
                    userInfo: 'getUserInfo',
                }
            ),

        },

        created(){
            this.getGroups();
            this.getUsers();
        },

        methods: {
            getGroups(){
                let requestUrl = {
                    url: UrlsService.groups,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {

                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        method: "get",
                        data: requestData
                    },
                };
                let messages = {
                    title: "Get groups",
                    loading: "Get groups",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.groups = responseSuccess;
                    });
            },
            closeDialog(){
                this.newUserDialog = false;
                this.getUsers(this.page)
            },
            closeDialogPassword(){
                this.changePasswordDialog = false;
                this.getUsers(this.page)
            },
            openNewUser(){
                this.newUserDialogText = "New user";
                this.newUserDialog = true;
                this.$refs.newUser.clear();
                this.$refs.newUser.disablePasswordFunction(false);
                this.$refs.newUser.setNewUser(true);
            },
            editItem(item){
                this.newUserDialogText = "Edit user";
                this.newUserDialog = true;
                this.$refs.newUser.disablePasswordFunction(true);
                this.$refs.newUser.fillFields(item);
                this.$refs.newUser.setNewUser(false);
            },
            changePassword(item){
                this.changePasswordDialog = true;
                this.$refs.changePassword.fillFields(item);
            },
            deleteUser(){
                let requestUrl = {
                    url: UrlsService.user + '/'+ this.itemToDelete.id,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {

                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        method: "delete",
                        data: requestData
                    },
                };
                let messages = {
                    title: "Delete user",
                    loading: "Delete user",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.dialogDeleteConfirm = false;
                        this.getUsers(this.page)

                    });

            },
            deleteIcon(item) {
                this.dialogDeleteConfirm = true;
                this.itemToDelete = item;
            },
            getUsers(){
                let requestUrl = {
                    url: UrlsService.user,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {

                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        method: "get",
                        data: requestData
                    },
                };
                let messages = {
                    title: "Get users",
                    loading: "Get users",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.users = response;
                        for (let i = 0; i < this.users.length; i++){
                            for (let j=0; j<this.groups.length; j++){
                                if(this.users[i].groupId === this.groups[j].id){
                                    this.users[i].groupName = this.groups[j].name;
                                    break;
                                }
                            }

                        }
                        if(this.userInfo.role === "APPROVER_INNOVATION"){
                            this.users = response.filter(function (el) {
                                return el.roleId === 6 || el.roleId === 7 || el.roleId === 9 ||  el.roleId === 10 || el.roleId === 11 || el.roleId === 13
                            });
                        }
                        else {
                            this.users = response.filter(function (el) {
                                return el.roleId === 6 || el.roleId === 7 || el.roleId === 9 || el.roleId === 10
                            });

                        }

                    });


            }
        },
    };
</script>

<style lang="scss">
    tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, .05);
    }
</style>

